function Hole(grossHolePar, holePar, addAsterisk, skins, highlightWinScore) {
  const root = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  };

  const commonStyle = {
    width: 36,
    height: 36,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    display: "flex",
    color: skins || highlightWinScore ? "white" : "rgba(30, 38, 46, 0.95)",
    fontFamily: "SF Pro Text",
    fontStyle: "normal",
    fontWeight: 400,
  };

  const outerSquare = {
    ...commonStyle,
    borderWidth: 1,
    borderColor:
      skins || highlightWinScore ? "white" : "rgba(30, 38, 46, 0.95)",
    borderStyle: "solid",
    borderRadius: 4,
  };

  const innerSquare = {
    ...outerSquare,
    margin: 1,
    width: 30,
    height: 30,
    borderRadius: 2,
  };

  const outerCircle = {
    ...outerSquare,
    borderRadius: 20,
  };

  const innerCircle = {
    ...outerCircle,
    ...innerSquare,
    borderRadius: 17,
  };

  const diff = grossHolePar - holePar;

  const dotAsteriskStyle = {
    fontFamily: "SF Pro Text",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 25,
  };

  const value = (style) =>
    addAsterisk ? (
      <div style={style}>
        {grossHolePar} <div style={dotAsteriskStyle}>•</div>
      </div>
    ) : (
      <div style={style}>{grossHolePar}</div>
    );

  if (grossHolePar === "-") {
    return <div style={root}>{value(commonStyle)}</div>;
  }
  if (Number.isNaN(grossHolePar) || diff === 0) {
    // nothing
    return <div style={root}>{value(commonStyle)}</div>;
  }
  if (diff === 1) {
    // single square
    return <div style={root}>{value(outerSquare)}</div>;
  }
  if (diff > 1) {
    // double square
    return (
      <div style={root}>
        <div style={outerSquare}>{value(innerSquare)}</div>
      </div>
    );
  }
  if (diff === -1) {
    // single circle
    return <div style={root}>{value(outerCircle)}</div>;
  }
  // double circle
  return (
    <div style={root}>
      <div style={outerCircle}>{value(innerCircle)}</div>
    </div>
  );
}

export { Hole };
